import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class PoliciesService {
  constructor(private http: HttpClient) { }

  // drop Down
  addEmpDeptmap(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/seats/add_emp_dept_map`,
      data
    );
  }
  checkOut(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/seats/check_out`,
      data
    );
  }
  seatSanitized(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/seats/seat_sanitized`,
      data
    );
  }
  selectCateg(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/policy/select_plcy_category`);
  }

  selectCategTopic(catID): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/policy/select_plcy_topic/` + catID
    );
  }

  categGet(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/policy/get_plcy_category?page=${data.page}&limit=${data.limit}`
    );
  }

  editCategStatus(stat, catID): Observable<any> {
    const option = {
      status: stat,
      cat_id: catID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/policy/edit_plcy_cat_status_action`,
      options
    );
  }

  editCateg(catID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/policy/edit_plcy_category/` + catID
    );
  }

  deleteCateg(catID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/policy/delete_plcy_category`, {
      cat_id: catID,
    });
  }

  addCateg(data: FormData, catID): Observable<any> {
    if (!catID) {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/add_plcy_cat_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/edit_plcy_category_action`,
        data
      );
    }
  }

  // Topic

  topicGet(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/policy/get_plcy_topics?page=${data.page}&limit=${data.limit}`
    );
  }

  editTopicStatus(stat, tpcID): Observable<any> {
    const option = {
      status: stat,
      tpc_id: tpcID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/policy/edit_plcy_topic_status_action`,
      options
    );
  }

  editTopic(tpcID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/policy/edit_plcy_topics/` + tpcID
    );
  }

  deleteTopic(tpcID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/policy/delete_plcy_topic`, {
      tpc_id: tpcID,
    });
  }

  addTopic(data: FormData, tpcID): Observable<any> {
    if (!tpcID) {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/add_plcy_topic_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/edit_plcy_topics_action`,
        data
      );
    }
  }

  // Subtopic

  sbtopicGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/policy/get_plcy_subtopic`,
      { params: param }
    );
  }

  editsbTopicStatus(stat, sbtpcID): Observable<any> {
    const option = {
      status: stat,
      subtpc_id: sbtpcID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/policy/edit_plcy_subtopic_status_action`,
      options
    );
  }

  editsbTopic(sbtpcID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/policy/edit_plcy_subtopic/` + sbtpcID
    );
  }

  deletesbTopic(sbtpcID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/policy/delete_plcy_subtopic`, {
      subtpc_id: sbtpcID,
    });
  }

  addsbTopic(data: FormData, sbtpcID): Observable<any> {
    if (!sbtpcID) {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/add_plcy_subtopic_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/edit_plcy_subtopic_action`,
        data
      );
    }
  }

  // Sub Topic data

  getsbTopicData(data, catID): Observable<any> {
    if (data.tpcID) {
      return this.http.get<any>(
        `${environment.apiUrl}/policy/get_documentvideo_bycatid/${catID}?tpc_id=${data.tpcID}`
      );
    } else {
      return this.http.get<any>(
        `${environment.apiUrl}/policy/get_documentvideo_bycatid/${catID}`
      );
    }
  }

  // workplace capping

  checkOfficeCapacity(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/policy/get_wrk_perm_allowed`,
      { params: param }
    );
  }

  myWorkPermissions(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/policy/get_mywork_permission`);
  }

  workplaceScopeGet(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/policy/select_wrk_perm_rgn`);
  }

  workplaceGet(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/policy/get_workpermission_scope?page=${data.page}&limit=${data.limit}`
    );
  }

  editWorkplaceStatus(stat, wrkplcID): Observable<any> {
    const option = {
      status: stat,
      scope_id: wrkplcID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/policy/edit_status_wrk_perm_scope`,
      options
    );
  }

  editWorkplace(wrkplcID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/policy/edit_workpermission_scope/` + wrkplcID
    );
  }

  addWorkplace(data, scopeID): Observable<any> {
    if (!scopeID) {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/add_work_scope_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/policy/edit_work_scope_action`,
        data
      );
    }
  }

  // check QR Code Status

  qrCodeStatus(req): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/policy/check_qr_code_status`,
      req
    );
  }

  checkInDetailSubmit(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/policy/check_in_detail_submit`,
      data
    );
  }

  wpReqCancel(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/cancel_wrkplc_perm_rqst`,
      data
    );
  }

  // pantry

  orderItem(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/policy/order_item`, data);
  }

  getPantryItems(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/policy/get_pantry_items`, {
      params: param,
    });
  }

  getOrderedItems(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/policy/pantry/get_ordered_item_list`,
      {
        params: param,
      }
    );
  }

  updateOrderStatus(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/pantry/update_order_status`,
      data
    );
  }

  getMostPolicy(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/policy/getMostPolicy`);
  }
}
